import { throwIfAborted } from '../abort.js';
import { fundingRateIsCurrent } from '../amount/fx.js';
import { fundingQuoteAmounts, reviewQuote } from './quote-review.js';
/** Rebind only the retained frame's quote. Never prepare or mount another attempt. */
export async function renewPaymentQuote(client, operation, attemptId, sessionProofId, quote, setQuote, signal, amountUnits) {
    throwIfAborted(signal);
    const checked = reviewQuote(quote, operation, Date.now());
    if (checked.state !== 'ready')
        throw new Error('onramp_quote_not_executable');
    await client.refreshAttemptQuote(operation.id, attemptId, quote.signature, quote.expiresAt, sessionProofId, signal, operation.receiveTarget || amountUnits !== undefined ? fundingQuoteAmounts(checked) : undefined, amountUnits);
    throwIfAborted(signal);
    if (Date.parse(quote.expiresAt) <= Date.now())
        throw new Error('onramp_quote_expired');
    if (operation.receiveTarget && !fundingRateIsCurrent(operation.receiveTarget.fx, Date.now()))
        throw new Error('funding_fx_unavailable');
    setQuote(quote.signature);
}
